// Product ids whose certified controllers (yuso_certification) the onboarding dropdowns list.
// 20 (bess_embedded_da_ib) supersedes 1, 12 (pvcurtailment_da_ib) supersedes 9 (FT-5192 / FT-5722).
export const BESS_CONTROLLER_PRODUCT_ID = 20;
export const PV_CURTAILMENT_CONTROLLER_PRODUCT_ID = 12;

export const controllersUrl = (apiBase: string, productId: number): string =>
  `${apiBase}/api/v1/sdp/controllers?product_id=${productId}`;
